import * as React from 'react';
import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { useSelector } from 'hooks/useSelector';
import { theme } from 'lib/theme';
import {
  selectAseCannotEditReason,
  selectAseStatus,
} from 'store/assessments/selectors';
import { str } from 'lib/str';

export const MessageEdit: React.FC = () => {
  const status = useSelector(selectAseStatus);
  const cannotEditReason = useSelector(selectAseCannotEditReason);
  return cannotEditReason === 'AssessorOnline' ? (
    <Card>
      <CardRow
        style={{ backgroundColor: theme.colors.orange10 }}
        label={`Assessment ${status.name}`}
        value={`You${str.apos}re in online mode. To make changes, download the property and open the assessment there`}
        labelAlignTop
      />
    </Card>
  ) : cannotEditReason === 'AssessorSubmitted' ? (
    <Card>
      <CardRow
        style={{ backgroundColor: theme.colors.orange10 }}
        label={`Assessment ${status.name}`}
        value="Changes can no longer be made to this assessment now its submitted"
        labelAlignTop
      />
    </Card>
  ) : cannotEditReason === 'NonAssessor' ? (
    <Card>
      <CardRow
        style={{ backgroundColor: theme.colors.orange10 }}
        label={`Assessment ${status.name}`}
        value="Only authors can make changes right now"
        labelAlignTop
      />
    </Card>
  ) : (
    false
  );
};
